import React, {Component} from 'react';
import App from "../App";
import "../assets/scss/dashboard.scss";
import {getData} from "../services/baseServices";
import Loader from "react-loader"
import moment from "moment";
import DateRangeFilter from "./reconciliation/common/DateRangeFilter";
import {getFormattedDate, getDate, getLocalAuthToken} from "../helper/utils";
import { Link } from "react-router-dom";

const authData = getLocalAuthToken();
class Dashboard extends Component {
    state = {
        start_date_time: moment().subtract(30, 'days'),
        end_date_time: moment(),
        dashboard_data: {},
        dashboard_summary: {},
        isLoading: true,
    }

    getStatistics =() => {
        getData("dashboard", {start_date_time: moment(this.state.start_date_time).format('YYYY-MM-DD'), end_date_time: moment(this.state.end_date_time).format('YYYY-MM-DD')})
            .then(res => {
                console.log("Dashboard Data:" + res)
                this.setState({
                    dashboard_data: res?.data,
                    isLoading: false
                }, () => {
                });
            })
            .catch(errMsg => {
                this.setState({isLoading: false});
                console.log('Error Message: ', errMsg)
            })
        getData("dashboard/order_summary")
        .then(res => {
            this.setState({
                dashboard_summary: res?.data,
                isLoading: false
            }, () => {
            });
        })
        .catch(errMsg => {
            this.setState({isLoading: false});
            console.log('Error Message: ', errMsg)
        })
    }

    componentDidMount() {
        this.setState({isLoading: true});
        this.getStatistics()
    }

    handleOnApply = (e, picker) => {
        this.setState({
            start_date_time: getFormattedDate(picker.startDate, ''),
            end_date_time: getFormattedDate(picker.endDate, '')
        })
        this.setState({
            temp_params: {
                ...this.state.temp_params,
                start_date_time: getFormattedDate(picker.startDate, "YYYY-MM-DD"),
                end_date_time: getFormattedDate(picker.endDate, "YYYY-MM-DD")
            }
        })
    }

    render() {
        const {dashboard_data, dashboard_summary} = this.state;

        return (
            <App layout="">
                <div className="main-content">
                    <Loader loaded={!this.state.isLoading}>
                        <div className="page-header">
                            <h2 className="page-title">Dashboard</h2>
                        </div>
                        

                        <div className="row px-0 py-2 pt-5" style={{background: 'rgba(205, 66, 86, 0.75)'}}>
                            <div className="col-3 h-100">
                                <div className="card-block shadow rounded">
                                    <div className="d-flex">
                                        <div className="w-25 d-flex justify-content-center align-items-center">
                                            <img src="/order_placed.svg" alt="order_place_logo" width="40px"/>
                                        </div>
                                        <div className="w-75 d-flex justify-content-center align-items-center flex-column text-center p-2" style={{minHeight: '110px'}}>
                                            <p className='m-0'><strong>{dashboard_summary?.order_processing_at_cwh}</strong></p>
                                            <p className='m-0'>Order Processing At CWH</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 h-100">
                                <div className="card-block shadow rounded">
                                    <div className="d-flex">
                                        <div className="w-25 d-flex justify-content-center align-items-center">
                                            <img src="/intransit_to_dh.svg" alt="intransit_to_dh_logo" width="40px"/>
                                        </div>
                                        <div className="w-75 d-flex justify-content-center align-items-center flex-column text-center p-2" style={{minHeight: '110px'}}>
                                            <p className='m-0'><strong>{dashboard_summary?.in_transit_to_dh}</strong></p>
                                            <p className='m-0'>In Transit To DH</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 h-100">
                                <div className="card-block shadow rounded" style={{padding: '0px'}}>
                                    <div className="d-flex">
                                        <div className="w-25 d-flex justify-content-center align-items-center">
                                            <img src="./delivery_pending.svg" alt="delivery_pending_logo" width="40px"/>
                                        </div>
                                        <div className="w-75 d-flex justify-content-center align-items-center flex-column text-center p-2 h-25" style={{minHeight: '110px'}}>
                                            <p className='m-0'><strong>{dashboard_summary?.delivery_pending}</strong></p>
                                            <p className='m-0'>OHS at Dist House</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 h-100">
                                <div className="card-block shadow rounded" style={{padding: '0px'}}>
                                    <div className="d-flex">
                                        <div className="w-25 d-flex justify-content-center align-items-center">
                                            <img src="./intransit_to_partner.svg" alt="order_place_logo" width="40px"/>
                                        </div>
                                        <div className="w-75 d-flex justify-content-center align-items-center flex-column text-center p-2 h-25" style={{minHeight: '110px'}}>
                                            <p className='m-0'><strong>{dashboard_summary?.in_transit_orders_count}</strong></p>
                                            <p className='m-0'> {authData?.details?.home_delivery ? 'Rider': 'SR'} In Transit Orders</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-3 h-100">
                                <div className="card-block shadow rounded" style={{padding: '0px'}}>
                                    <div className="d-flex">
                                        <div className="w-25 d-flex justify-content-center align-items-center">
                                            <img src="./delivery_pending.svg" alt="delivery_pending_logo" width="40px"/>
                                        </div>
                                        <div className="w-75 d-flex justify-content-center align-items-center flex-column text-center p-2 h-25" style={{minHeight: '110px'}}>
                                            <p className='m-0'><strong>{dashboard_summary?.return_request}</strong></p>
                                            <p className='m-0'>Return Requests</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 h-100">
                                <div className="card-block shadow rounded" style={{padding: '0px'}}>
                                    <div className="d-flex">
                                        <div className="w-25 d-flex justify-content-center align-items-center">
                                            <img src="./intransit_to_partner.svg" alt="order_place_logo" width="40px"/>
                                        </div>
                                        <div className="w-75 d-flex justify-content-center align-items-center flex-column text-center p-2 h-25" style={{minHeight: '110px'}}>
                                            <p className='m-0'><strong>{dashboard_summary?.return_collectable_by_sr}</strong></p>
                                            <p className='m-0'>Return Collected By {authData?.details?.home_delivery ? 'Rider': 'SR'}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div align="left" className='row pt-4 pl-3' style={{background: 'rgba(33, 64, 154, 0.75)'}}>
                            <DateRangeFilter start_date_time={this.state.start_date_time}
                                            end_date_time={this.state.end_date_time}
                                            handleOnApply={(e, picker) => this.handleOnApply(e, picker)}
                                            variant="success"
                                            max={1}
                                            filterList={this.getStatistics}/>
                        </div>
                        <div className="row  px-0 py-2" style={{background: 'rgba(33, 64, 154, 0.75)'}}>
                            <div className="col-3 h-100">
                                <div className="card-block shadow rounded">
                                    <div className="d-flex">
                                        <div className="w-25 d-flex justify-content-center align-items-center">
                                            <img src="/order_placed.svg" alt="order_place_logo" width="40px"/>
                                        </div>
                                        <div className="w-75 d-flex justify-content-center align-items-center flex-column text-center p-2" style={{minHeight: '110px'}}>
                                            <p className='m-0'><strong>{dashboard_data?.total_completed_order}</strong></p>
                                            <p className='m-0'>Total Completed Orders</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 h-100">
                                <div className="card-block shadow rounded">
                                    <div className="d-flex">
                                        <div className="w-25 d-flex justify-content-center align-items-center">
                                            <img src="/intransit_to_dh.svg" alt="intransit_to_dh_logo" width="40px"/>
                                        </div>
                                        <div className="w-75 d-flex justify-content-center align-items-center flex-column text-center p-2" style={{minHeight: '110px'}}>
                                            <p className='m-0'><strong>{parseFloat(dashboard_data?.total_completed_order_value)?.toFixed(2)}</strong></p>
                                            <p className='m-0'>Total Completed Order Value</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 h-100">
                                <div className="card-block shadow rounded" style={{padding: '0px'}}>
                                    <div className="d-flex">
                                        <div className="w-25 d-flex justify-content-center align-items-center">
                                            <img src="./collectable_return.svg" alt="collectable_returns_logo" width="40px"/>
                                        </div>
                                        <div className="w-75 d-flex justify-content-center align-items-center flex-column text-center p-2 h-25" style={{minHeight: '110px'}}>
                                            <p className='m-0'><strong>{parseFloat(dashboard_data?.dist_margin)?.toFixed(2)}</strong></p>
                                            <p className='m-0'>DH Margin</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 h-100">
                                <div className="card-block shadow rounded" style={{padding: '0px'}}>
                                    <div className="d-flex">
                                        <div className="w-25 d-flex justify-content-center align-items-center">
                                            <img src="./collectable_cash.svg" alt="collectable_cash_logo" width="40px"/>
                                        </div>
                                        <div className="w-75 d-flex justify-content-center align-items-center flex-column text-center p-2 h-25" style={{minHeight: '110px'}}>
                                            <p className='m-0'><strong>{parseFloat(dashboard_data?.partner_margin)?.toFixed(2)}</strong></p>
                                            <p className='m-0'>Partner Margin</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                            <div className="col-3 h-100">
                                <div className="card-block shadow rounded" style={{padding: '0px'}}>
                                    <div className="d-flex">
                                        <div className="w-25 d-flex justify-content-center align-items-center">
                                            <img src="./collectable_cash.svg" alt="collectable_cash_logo" width="40px"/>
                                        </div>
                                        <div className="w-75 d-flex justify-content-center align-items-center flex-column text-center p-2 h-25" style={{minHeight: '110px'}}>
                                            <p className='m-0'><strong>{parseFloat(dashboard_data?.collectable_cash_from_market)?.toFixed(2)}</strong></p>
                                            <p className='m-0'>Collectable Cash From Market</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 h-100">
                                <div className="card-block shadow rounded" style={{padding: '0px'}}>
                                    <div className="d-flex">
                                        <div className="w-25 d-flex justify-content-center align-items-center">
                                            <img src="./collectable_return.svg" alt="collectable_returns_logo" width="40px"/>
                                        </div>
                                        <div className="w-75 d-flex justify-content-center align-items-center flex-column text-center p-2 h-25" style={{minHeight: '110px'}}>
                                            <p className='m-0'><strong>{parseFloat(authData?.details?.home_delivery ? dashboard_data?.collected_by_rider : dashboard_data?.cash_collected_by_sr)?.toFixed(2)}</strong></p>
                                            <p className='m-0'>Cash Collected By {authData?.details?.home_delivery ? 'Rider': 'SR'}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 h-100">
                                <div className="card-block shadow rounded" style={{padding: '0px'}}>
                                    <div className="d-flex">
                                        <div className="w-25 d-flex justify-content-center align-items-center">
                                            <img src="./collectable_return.svg" alt="collectable_returns_logo" width="40px"/>
                                        </div>
                                        <div className="w-75 d-flex justify-content-center align-items-center flex-column text-center p-2 h-25" style={{minHeight: '110px'}}>
                                            <p className='m-0'><strong>{parseFloat(dashboard_data?.cash_deposit_to_shopoth)?.toFixed(2)}</strong></p>
                                            <p className='m-0'>Cash deposited to Shopoth</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 h-100">
                                <div className="card-block shadow rounded" style={{padding: '0px'}}>
                                    <div className="d-flex">
                                        <div className="w-25 d-flex justify-content-center align-items-center">
                                            <img src="./collectable_return.svg" alt="collectable_returns_logo" width="40px"/>
                                        </div>
                                        <div className="w-75 d-flex justify-content-center align-items-center flex-column text-center p-2 h-25" style={{minHeight: '110px'}}>
                                            <p className='m-0'><strong>{parseFloat(dashboard_data?.total_completed_online_orders_value)?.toFixed(2)}</strong></p>
                                            <p className='m-0'>Total Online Orders value</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            {/* <div className="col-3 h-100">
                                <div className="card-block shadow rounded" style={{padding: '0px'}}>
                                    <div className="d-flex">
                                        <div className="w-25 d-flex justify-content-center align-items-center">
                                            <img src="./collectable_cash.svg" alt="collectable_cash_logo" width="40px"/>
                                        </div>
                                        <div className="w-75 d-flex justify-content-center align-items-center flex-column text-center p-2 h-25" style={{minHeight: '110px'}}>
                                            <p className='m-0'><strong>{dashboard_data?.campaign_names?.[0] || 'N/A'}</strong></p>
                                            <p className='m-0'>Campaign Names</p>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>

                        <div className='row px-0 py-2' style={{background: 'rgba(33, 64, 154, 0.75)'}}>
                            <div className='col-12'>
                                <h4 className='text-center'>Intransit Orders</h4>

                                <table className="order-table table table-striped">
                                    <thead>
                                    <tr className='bg-white'>
                                        <th style={{width: '20px'}}>#</th>
                                        <th>ORDER DATE</th>
                                        <th>SHIPPING TYPE</th>
                                        <th>STATUS</th>
                                        <th>PRICE</th>
                                        <th>Deadline</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {dashboard_summary?.in_transit_orders?.length > 0 ? dashboard_summary?.in_transit_orders?.map((order, index) => {
                                        return (
                                            <tr key={index} className="bg-white">
                                                <td>
                                                    <Link
                                                        to={`/customerOrder/details/${order.order_id}`}
                                                        className="btn btn-sm btn-success"
                                                    >
                                                        {order.order_id}
                                                    </Link>
                                                </td>
                                                <td>{moment(order.date).format('DD/MM/YYYY')}</td>
                                                <td>{order.shipping_type}</td>
                                                <td>{order.status_type}</td>
                                                <td>{parseFloat(order.price)?.toFixed(2)}</td>
                                                <td>{order?.shipping_type === "home_delivery" ?
                                                getDate(order?.date).add(3, 'hours').format('LT, ll')
                                                :getDate(order?.date).add(72, 'hours').format('LT, ll')
                                                }</td>
                                            </tr>
                                        )
                                    })
                                    :
                                    <tr><td className='text-center' colSpan={5}>No data found</td></tr>
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Loader>
                </div>
            </App>
        );
    }
}

export default Dashboard;
